import { render, staticRenderFns } from "./TalentButtonSilder.vue?vue&type=template&id=7b578e54&scoped=true&"
import script from "./TalentButtonSilder.vue?vue&type=script&lang=js&"
export * from "./TalentButtonSilder.vue?vue&type=script&lang=js&"
import style0 from "./TalentButtonSilder.vue?vue&type=style&index=0&id=7b578e54&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7b578e54",
  null
  
)

export default component.exports